"use client";

import { useTranslations } from "next-intl";
import CopyToClipboard from "react-copy-to-clipboard";
import Copy from "@/assets/icons/copy.svg";
import { toast } from "@/components/ui/sonner";

export const OrderNumberInline = ({ displayId }: { displayId: string }) => {
  const t = useTranslations("orderStatus");

  return (
    <span className="inline-flex items-center gap-1 whitespace-nowrap font-medium text-brand-green1-300">
      <span className="text-brand-violet">{displayId}</span>
      <CopyToClipboard onCopy={() => toast.info(t("copied"))} text={displayId}>
        <button
          aria-label={t("orderId")}
          className="inline-flex hover:cursor-pointer"
          type="button"
        >
          <Copy className="h-4 min-h-4 w-4 min-w-4 [&>path]:fill-brand-green2-300/80" />
        </button>
      </CopyToClipboard>
    </span>
  );
};
